import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
  className?: string;
}

const Trash = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size} className={props.className}>
    <path d="M2 5H22" stroke="currentColor" strokeWidth="2" />
    <path
      d="M10 1H14C14.5304 1 15.0391 1.21071 15.4142 1.58579C15.7893 1.96086 16 2.46957 16 3V5H8V3C8 2.46957 8.21071 1.96086 8.58579 1.58579C8.96086 1.21071 9.46957 1 10 1Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M12 9V19" stroke="currentColor" strokeWidth="2" />
    <path d="M8 9V19" stroke="currentColor" strokeWidth="2" />
    <path d="M16 9V19" stroke="currentColor" strokeWidth="2" />
    <path
      d="M19 6V21C19 21.2652 18.8946 21.5196 18.7071 21.7071C18.5196 21.8946 18.2652 22 18 22H6C5.73478 22 5.48043 21.8946 5.29289 21.7071C5.10536 21.5196 5 21.2652 5 21V6H19ZM21 4H3V21C3 21.7956 3.31607 22.5587 3.87868 23.1213C4.44129 23.6839 5.20435 24 6 24H18C18.7956 24 19.5587 23.6839 20.1213 23.1213C20.6839 22.5587 21 21.7956 21 21V4Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default Trash;
